import ManualPayment from 'features/payOverTime/screens/payments/ManualPayment/ManualPayment';
import React from 'react';

export default function ManualPaymentScreen() {
  return <ManualPayment />;
}
